import { createSlice } from '@reduxjs/toolkit'

export const godSlice = createSlice({
  name: 'god',
  initialState: {
    value: false
  },
  reducers: {
    setGod: (state, data) => {
      // Redux Toolkit allows us to write "mutating" logic in reducers. It
      // doesn't actually mutate the state because it uses the Immer library,
      // which detects changes to a "draft state" and produces a brand new
      // immutable state based off those changes
      state.value = data.payload.is_god
    },
  },
})

// Action creators are generated for each case reducer function
export const { setGod } = godSlice.actions

export default godSlice.reducer